import find from 'lodash/find';
import sortBy from 'lodash/sortBy';
import forEach from 'lodash/forEach';
import compact from 'lodash/compact';
import without from 'lodash/without';
import map from 'lodash/map';
import flatten from 'lodash/flatten';
import UserDatabases from '@Services/UserDatabases';

function isAdditionalInfoVisible(detail) {
  return (
    isReactantsProductsVisible(detail) ||
    isReagentsVisible(detail) ||
    hasCollection(detail.protectingGroups) ||
    hasCollection(detail.metabolizationGroups)
  );
}

function isCIDatabase(databaseId) {
  return UserDatabases.isCIDatabase(databaseId);
}

function hasCollection(collection) {
  return collection && collection.length > 0;
}

function isReagentsVisible(detail) {
  if (!detail.stages) {
    return false;
  }

  for (let i = 0; i < detail.stages.length; i++) {
    if (
      hasCollection(detail.stages[i].reagents) ||
      hasCollection(detail.stages[i].solvents) ||
      hasCollection(detail.stages[i].catalysts)
    ) {
      return true;
    }
  }

  return false;
}

function isReactantsProductsVisible(detail) {
  return hasCollection(detail.reactants) || hasCollection(detail.products);
}

function isReactantsProductsOnStageVisible(detail) {
  /*Extra condition detail.stages && detail.stages.length <= 1 was added per story XFE-5682*/
  if (!detail.stages || (detail.stages && detail.stages.length <= 1)) {
    return false;
  }

  for (let i = 0; i < detail.stages.length; i++) {
    if (isReactantsProductsVisible(detail.stages[i])) {
      return true;
    }
  }

  return false;
}

function getStage(row) {
  if (!row || !row.cells || !Array.isArray(row.cells)) {
    return null;
  }
  const stageCell = find(row.cells, (cell) => cell && cell.id === 'stage');
  return stageCell ? stageCell.value : null;
}

function getDetailData(part, detail) {
  return detail[part];
}

function getDetailDataOnStagesLevel(part, detail) {
  let flattened = flatMap(detail.stages, stage => {
    return stage[part];
  });

  return sortBy(flattened, 'stage');
}

function getReagentsSolventsCatalystsOnStagesLevel(detail) {
  const extractData = (collection, role) => {
    return flatMap(detail.stages, stage => {
      return forEach(stage[collection], item => {
        item.role = role;
      });
    });
  };

  let reagents = extractData('reagents', 'Reagent');
  let solvents = extractData('solvents', 'Solvent');
  let catalysts = extractData('catalysts', 'Catalyst');

  let allData = [].concat(reagents, solvents, catalysts);
  allData = compact(allData);
  return sortBy(allData, 'stage');
}

function flatMap(stages, mapFn) {
  let targetCollections = without(map(stages, mapFn), undefined);

  forEach(targetCollections, (collection, stageIndex) => {
    forEach(collection, item => {
      item.stage = (stageIndex + 1).toString();
    });
  });

  return flatten(targetCollections);
}

/**
 * @ngdoc service
 * @name app.results:ReactReactionAdditionalInfoHelper
 * @requires UserDatabases
 * @returns {object} helper service for React reaction additional info
 * @description helper service for React reaction additional info
 */
const ReactReactionAdditionalInfoHelper = {
  isAdditionalInfoVisible,
  isCIDatabase,
  isReagentsVisible,
  isReactantsProductsVisible,
  isReactantsProductsOnStageVisible,
  hasCollection,
  getStage,
  getDetailData,
  getDetailDataOnStagesLevel,
  getReagentsSolventsCatalystsOnStagesLevel,
};

export default ReactReactionAdditionalInfoHelper;
